import Overview from './overview.vue';
import Full from '@rebuild/materials/shared/customs_calendar/FullIndex.vue';
import MobOverview from '@rebuild/materials/shared/customs_calendar/mobile/MobOverviewIndex.vue';
import MobFull from '@rebuild/materials/shared/customs_calendar/mobile/FullIndex.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	'mob-overview': MobOverview,
	'mob-full': MobFull
}; 